import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {injectable} from "tsyringe";
import {transformer} from "../decorators/transformer.decorator";
import {DeleteProjectCommand} from "../commands/delete-project.command";
import {Project} from "../domain/entities/project.entity";

@injectable()
@transformer({
    source: DeleteProjectCommand,
    target: `dto`
})
export class DeleteProjectCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Project> {

    protected async toDTO(project: Project): Promise<DataTransferObject> {
        return Promise.resolve(<DataTransferObject>{ uid: project.uid });
    }

}
